// src/StripeMask.jsx
import React from 'react';
import './StripeMask.css';

export default function StripeMask() {
  return <div className="stripe-mask" style={{opacity: 1}}/>;
}